import type { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import Checkbox from '@/components/Checkbox/Checkbox'
import FormField from '@/components/FormField'
import Select from '@/components/Select/Select'
import Textarea from '@/components/Textarea/Textarea'
import FileUploader from '@/components/common/FileUploader/FileUploader'
import { useFiles } from '@/hooks/useUploadFile'

import styles from './AbsencesPlanFormDetails.module.scss'
import FormFooter from './FormFooter'
import { MAX_FILE_SIZE } from '../constants/max-file-size'
import useAbsenceReasonOptions from '../queries/useAbsenceReasonOptions'
import type { AbsencesPlanFormPayload } from '../utils/create-absence-plan-schema'

type AbsenceFormDetailsProps = {
  form: UseFormReturn<AbsencesPlanFormPayload>
}

const AbsenceFormDetails = (props: AbsenceFormDetailsProps) => {
  const { t } = useTranslation('absences2')

  const {
    data: absenceReasonOptions,
    isLoading: isLoadingAbsenceReasonOptions
  } = useAbsenceReasonOptions()

  const fileUpload = useFiles([], value =>
    props.form.setValue('attachments', value)
  )

  return (
    <div className={styles.right}>
      <div className={styles.formDetails}>
        <div className={styles.formFields}>
          <FormField
            control={props.form.control}
            id="absence-reason"
            label={t('label.absence-reason')}
            name="reason"
            className={styles.reasonSelect}
            required
            render={({ inputProps }) => (
              <Select
                {...inputProps}
                options={absenceReasonOptions ?? []}
                placeholder={t('placeholder.select-absence-reason')}
                loading={isLoadingAbsenceReasonOptions}
              />
            )}
          />
          <FormField
            control={props.form.control}
            id="comment"
            label={t('label.comment')}
            name="comment"
            render={({ inputProps }) => (
              <Textarea
                {...inputProps}
                placeholder={t('placeholder.type-comment')}
                numberOfLines={7}
              />
            )}
          />
          <FormField
            control={props.form.control}
            id="send-for-guardian-reviee"
            name="sendForGuardianReview"
            render={({ inputProps }) => (
              <Checkbox
                label={t('label.send-for-guardian-review')}
                {...inputProps}
              />
            )}
          />
        </div>
        <FileUploader
          id="absence-plan-form-attachment"
          label={t('label.attachment')}
          attachmentType="absence"
          maxSize={MAX_FILE_SIZE}
          {...fileUpload}
        />
      </div>
      <FormFooter />
    </div>
  )
}

export default AbsenceFormDetails
